import { defineMessages } from 'react-intl'

const scope = `procurify.core.components.PrimaryCategorySelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select a {singularPrimaryOrgCategoryLabel}',
  },
})
